/**
 * Helpers de presentación de personas (propietario, copropietarios, autorizados).
 * Los usan el paso de propietario, el de autorizados y la confirmación para
 * mostrar siempre el mismo nombre y la misma línea de datos.
 */

// Razón social si es sociedad, si no nombre + apellidos, si no la cédula.
export function nombreDe(persona = {}) {
  return (
    persona.nombre_sociedad ||
    `${persona.nombre || ""} ${persona.apellidos || ""}`.trim() ||
    persona.cedula ||
    "Sin nombre"
  );
}

// Iniciales para el avatar: primer nombre + primer apellido (CM, VM, JA).
// Si es sociedad o solo hay un dato, se usan las dos primeras letras.
export function inicialesDe(persona = {}) {
  const primera = (txt) => String(txt || "").trim().split(/\s+/)[0] || "";
  const n = primera(persona.nombre);
  const a = primera(persona.apellidos);
  if (n && a) return (n[0] + a[0]).toUpperCase();
  const suelto = primera(persona.nombre_sociedad) || n || a;
  if (suelto) return suelto.slice(0, 2).toUpperCase();
  return "--";
}

// Primer teléfono con dato: celular → casa → trabajo ("-" significa que no tiene).
export function telefonoDe(persona = {}) {
  return [persona.telefono_cel, persona.telefono_casa, persona.telefono_trabajo].find(
    (t) => t && String(t).trim() !== "" && String(t).trim() !== "-",
  );
}

export function placasDe(persona = {}) {
  return (persona.vehiculos || [])
    .map((v) => String(v.placa || "").trim().toUpperCase())
    .filter(Boolean);
}

// Línea secundaria de las tarjetas: cédula · teléfono · placas
export function metaDe(persona = {}) {
  return [persona.cedula, telefonoDe(persona), placasDe(persona).join(", ")]
    .filter(Boolean)
    .join("  ·  ");
}
